import { render, staticRenderFns } from "./VueSmartSwitch.vue?vue&type=template&id=7a180c48&scoped=true&"
import script from "./VueSmartSwitch.vue?vue&type=script&lang=ts&"
export * from "./VueSmartSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./VueSmartSwitch.vue?vue&type=style&index=0&id=7a180c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a180c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a180c48')) {
      api.createRecord('7a180c48', component.options)
    } else {
      api.reload('7a180c48', component.options)
    }
    module.hot.accept("./VueSmartSwitch.vue?vue&type=template&id=7a180c48&scoped=true&", function () {
      api.rerender('7a180c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/switch/VueSmartSwitch.vue"
export default component.exports